import { ApolloError } from '@apollo/client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PermanentDeleteMessageBulkMutationFn } from 'generated/graphql';

interface PermanentDeleteMessageBulkResponse {
  success?: boolean;
  error?: ApolloError | undefined;
  messageUids: number[];
  mailboxId?: string;
}

interface PermanentDeleteMessageBulkArgs {
  payload: {
    mailboxId: string;
    messageUids: number[];
  };
  permanentDeleteMessageBulkHook: PermanentDeleteMessageBulkMutationFn;
}

export const permanentDeleteMessageBulkThunk = createAsyncThunk(
  'permanentDeleteMessageBulk',
  async (arg: PermanentDeleteMessageBulkArgs): Promise<PermanentDeleteMessageBulkResponse> => {
    try {
      const response = await arg.permanentDeleteMessageBulkHook({
        variables: {
          mailboxId: arg.payload.mailboxId,
          messageUids: arg.payload.messageUids,
        },
      });
      return {
        success: response?.data?.deleteMessageBulk.success || false,
        messageUids: arg.payload.messageUids,
        mailboxId: arg.payload.mailboxId,
      };
    } catch (e) {
      return {
        messageUids: arg.payload.messageUids,
        error: e as ApolloError,
      };
    }
  }
);
